<script setup>
import AddNewChldItem from './AddNewChldItem.vue';
</script>
<template>
  <div class="child-details-container">
    <div class="content-header">
      <div class="header-icon">
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
          <circle cx="12" cy="7" r="4"/>
        </svg>
      </div>
      <h1 v-if="!isDancerRoute">Diák és szülő információk</h1>
      <h1 v-else>Saját adataim</h1>
      <p v-if="!isDancerRoute">Táncos részletes adatainak megtekintése és kezelése</p>
      <p v-else>Saját táncos profilod megtekintése</p>
    </div>

    <div v-if="childInfo" class="content-wrapper">
      <AddNewChldItem v-if="!isAdmin && !isDancerRoute" :parent_1_mail="childInfo.parent1Email" :parent_2_mail="childInfo.parent2Email.String" />

      <!-- Profile Edit Controls -->
      <div class="admin-controls" v-if="isAdmin || canEditProfile()">
        <button 
          v-if="!isEditingEnabled" 
          class="modern-btn modern-btn--secondary" 
          @click="enableEditing"
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
            <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
          </svg>
          Adatok módosítása
        </button>
        <button 
          v-if="isEditingEnabled" 
          class="modern-btn modern-btn--danger" 
          @click="disableEditing"
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <rect x="3" y="3" width="18" height="18" rx="2" ry="2"/>
            <line x1="9" y1="9" x2="15" y2="15"/>
            <line x1="15" y1="9" x2="9" y2="15"/>
          </svg>
          Módosítás letiltása
        </button>
      </div>

    <div v-if="upcomingLessons.length || upcomingCompetitions.length" class="events-section">
      <div v-if="upcomingLessons.length" class="lessons-section">
        <h2>Közelgő táncórák</h2>
        <div class="lesson-list">
          <div v-for="lesson in upcomingLessons" :key="lesson.id" class="lesson-card">
            <div class="lesson-card__name">{{ lesson.name }}</div>
            <div class="lesson-card__details">
              <span class="lesson-card__date">{{ lesson.next_dates }}</span>
              <span class="lesson-card__schedule">{{ parseSchedule(lesson.schedule) }}</span>
            </div>
          </div>
        </div>
      </div>
      <div v-if="upcomingCompetitions.length" class="competitions-section">
        <h2>Közelgő versenyek</h2>
        <div class="competition-list">
          <div v-for="comp in upcomingCompetitions" :key="comp.id" class="competition-card">
            <div class="comp-date">{{ comp.comp_date }}</div>
            <div class="comp-title">{{ comp.title }}</div>
          </div>
        </div>
      </div>
    </div>
      <!-- Child Information Cards -->
      <div class="info-grid">
        <!-- Diák adatai -->
        <div class="info-card">
          <div class="card-header">
            <div class="card-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
                <circle cx="12" cy="7" r="4"/>
              </svg>
            </div>
            <h3>Diák adatai</h3>
          </div>
          
          <div class="info-list">
            <div class="info-item">
              <div class="info-label">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M9 12l2 2 4-4"/>
                  <path d="M21 12c-1 0-3-1-3-3s2-3 3-3 3 1 3 3-2 3-3 3"/>
                  <path d="M3 12c1 0 3-1 3-3s-2-3-3-3-3 1-3 3 2 3 3 3"/>
                  <path d="M12 3c0 1-1 3-3 3s-3-2-3-3 1-3 3-3 3 2 3 3"/>
                  <path d="M12 21c0-1 1-3 3-3s3 2 3 3-1 3-3 3-3-2-3-3"/>
                </svg>
                Fejlődés
              </div>
              <div class="info-value" v-if="(isAdmin || canEditProfile()) && isEditingEnabled" @dblclick="editField('childxskill')">
                <span v-if="!isEditingField.childxskill">{{ childInfo.childxskill || 'Nincs megadva' }}</span>
                <textarea v-if="isEditingField.childxskill" v-model="childInfo.childxskill" @keydown.enter="updateFieldChild('childxskill')" @blur="updateFieldChild('childxskill')" class="modern-input"></textarea>
              </div>
              <div class="info-value" v-else>{{ childInfo.childxskill || 'Nincs megadva' }}</div>
            </div>

            <div class="info-item">
              <div class="info-label">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
                  <circle cx="12" cy="7" r="4"/>
                </svg>
                Vezetéknév
              </div>
              <div class="info-value" v-if="(isAdmin || canEditProfile()) && isEditingEnabled" @dblclick="editField('childxfamily_name')">
                <span v-if="!isEditingField.childxfamily_name">{{ childInfo.childxfamily_name }}</span>
                <input v-if="isEditingField.childxfamily_name" v-model="childInfo.childxfamily_name" @keydown.enter="updateFieldChild('childxfamily_name')" @blur="updateFieldChild('childxfamily_name')" class="modern-input">
              </div>
              <div class="info-value" v-else>{{ childInfo.childxfamily_name }}</div>
            </div>

            <div class="info-item">
              <div class="info-label">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
                  <circle cx="12" cy="7" r="4"/>
                </svg>
                Keresztnév
              </div>
              <div class="info-value" v-if="(isAdmin || canEditProfile()) && isEditingEnabled" @dblclick="editField('childxsure_name')">
                <span v-if="!isEditingField.childxsure_name">{{ childInfo.childxsure_name }}</span>
                <input v-if="isEditingField.childxsure_name" v-model="childInfo.childxsure_name" @keydown.enter="updateFieldChild('childxsure_name')" @blur="updateFieldChild('childxsure_name')" class="modern-input">
              </div>
              <div class="info-value" v-else>{{ childInfo.childxsure_name }}</div>
            </div>

            <div class="info-item">
              <div class="info-label">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
                  <circle cx="12" cy="10" r="3"/>
                </svg>
                Lakcím
              </div>
              <div class="info-value" v-if="(isAdmin || canEditProfile()) && isEditingEnabled" @dblclick="editField('childxaddr')">
                <span v-if="!isEditingField.childxaddr">{{ childInfo.childxaddr || 'Nincs megadva' }}</span>
                <input v-if="isEditingField.childxaddr" v-model="childInfo.childxaddr" @keydown.enter="updateFieldChild('childxaddr')" @blur="updateFieldChild('childxaddr')" class="modern-input">
              </div>
              <div class="info-value" v-else>{{ childInfo.childxaddr || 'Nincs megadva' }}</div>
            </div>

            <div class="info-item" v-if="isAdmin || isTeacher">
              <div class="info-label">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
                </svg>
                Versenyző
              </div>
              <div class="info-value">
                <label class="toggle-switch">
                  <input type="checkbox" :checked="childInfo.is_competitor" @change="updateCompetitor($event.target.checked)">
                  <span class="toggle-slider"></span>
                  <span class="toggle-text">{{ childInfo.is_competitor ? 'Igen (Versenyző)' : 'Nem' }}</span>
                </label>
              </div>
            </div>

            <template v-if="isDancerRoute">
              <div class="info-item">
                <div class="info-label">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                    <polyline points="22,6 12,13 2,6"/>
                  </svg>
                  Email
                </div>
                <div class="info-value">{{ childInfo.parent1Email || 'Nincs megadva' }}</div>
              </div>

              <div class="info-item">
                <div class="info-label">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
                  </svg>
                  Telefonszám
                </div>
                <div class="info-value" v-if="(isAdmin || canEditProfile()) && isEditingEnabled" @dblclick="editField('parent1xphone')">
                  <span v-if="!isEditingField.parent1xphone">{{ childInfo.parent1xphone || 'Nincs megadva' }}</span>
                  <input v-if="isEditingField.parent1xphone" v-model="childInfo.parent1xphone" @keydown.enter="updateFieldParent('parent1xphone',childInfo.parent1Email)" @blur="updateFieldParent('parent1xphone',childInfo.parent1Email)" class="modern-input">
                </div>
                <div class="info-value" v-else>{{ childInfo.parent1xphone || 'Nincs megadva' }}</div>
              </div>

              <div class="info-item" v-if="childInfo.mainUserBirthDate && childInfo.mainUserBirthDate.Valid">
                <div class="info-label">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
                    <line x1="16" y1="2" x2="16" y2="6"/>
                    <line x1="8" y1="2" x2="8" y2="6"/>
                    <line x1="3" y1="10" x2="21" y2="10"/>
                  </svg>
                  Születési dátum
                </div>
                <div class="info-value">{{ childInfo.mainUserBirthDate.String }}</div>
              </div>
            </template>
          </div>
        </div>

        <!-- Csoport információ -->
        <div class="info-card">
          <div class="card-header">
            <div class="card-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
                <circle cx="9" cy="7" r="4"/>
                <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
                <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
              </svg>
            </div>
            <h3>Csoport információ</h3>
          </div>
          
          <div class="info-list">
            <div class="info-item">
              <div class="info-label">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
                  <circle cx="9" cy="7" r="4"/>
                </svg>
                Csoportok
              </div>
              <div class="info-value">
                <div class="groups-display">
                  <div v-if="childGroups.length === 0" class="no-groups">
                    Nincs hozzárendelt csoport
                  </div>
                  <div v-else class="groups-list">
                    <span
                      v-for="group in childGroups"
                      :key="group.id"
                      :class="['group-badge', { 'group-badge--primary': group.is_primary }]"
                    >
                      {{ group.group_name }}
                      <span v-if="group.is_primary" class="primary-indicator">(Elsődleges)</span>
                      <button
                        v-if="!group.is_primary && (isAdmin || isTeacher || isAssistant)"
                        @click="setPrimaryGroup(group.group_id)"
                        class="set-primary-btn"
                        title="Beállítás elsődlegesnek"
                      >
                        ★
                      </button>
                      <button
                        v-if="isAdmin || isTeacher || isAssistant"
                        @click="removeGroup(group.group_id)"
                        class="remove-group-btn"
                        title="Csoport eltávolítása"
                      >
                        ×
                      </button>
                    </span>
                  </div>
                  <div v-if="isAdmin || isTeacher || isAssistant" class="group-actions">
                    <button
                      v-if="!isAddingGroup"
                      @click="startAddingGroup"
                      class="modern-btn modern-btn--primary"
                    >
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <line x1="12" y1="5" x2="12" y2="19"/>
                        <line x1="5" y1="12" x2="19" y2="12"/>
                      </svg>
                      Csoport hozzáadása
                    </button>
                    <div v-if="isAddingGroup" class="add-group-form">
                      <select
                        v-model="selectedGroupToAdd"
                        class="modern-select"
                        style="margin-right: 0.5rem;"
                      >
                        <option value="">Válassz csoportot...</option>
                        <option
                          v-for="group in availableGroupsForUser"
                          :key="group.id"
                          :value="group.id"
                          :disabled="childGroups.some(cg => cg.group_id === group.id)"
                        >
                          {{ group.name }}
                        </option>
                      </select>
                      <label class="checkbox-group" style="margin-right: 0.5rem;">
                        <input
                          type="checkbox"
                          v-model="isPrimaryForNewGroup"
                          class="modern-checkbox"
                        >
                        <span class="checkbox-custom"></span>
                        Elsődleges csoport
                      </label>
                      <button
                        @click="addGroup"
                        class="modern-btn modern-btn--success"
                        :disabled="!selectedGroupToAdd"
                      >
                        Hozzáadás
                      </button>
                      <button
                        @click="cancelAddingGroup"
                        class="modern-btn modern-btn--secondary"
                      >
                        Mégse
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="info-item" v-if="(isAdmin || isTeacher || isAssistant) && childInfo.childDesiredGrpId && childInfo.childDesiredGrpId.Valid">
              <div class="info-label">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M9 12l2 2 4-4"/>
                </svg>
                Kívánt csoport
              </div>
              <div class="info-value">
                <span class="group-badge group-badge--desired">{{ getGroupNameById(childInfo.childDesiredGrpId.Int64) }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Diák pénzügyek és adatok -->
        <div class="info-card" v-if="isAdmin || isTeacher || isAssistant">
          <div class="card-header">
            <div class="card-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M12 2v20M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/>
              </svg>
            </div>
            <h3>Diák pénzügyek és adatok</h3>
          </div>

          <div class="info-list">
            <!-- Birth date (Year / Month) -->
            <div class="info-item">
              <div class="info-label">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
                  <line x1="16" y1="2" x2="16" y2="6"/>
                  <line x1="8" y1="2" x2="8" y2="6"/>
                  <line x1="3" y1="10" x2="21" y2="10"/>
                </svg>
                Születési idő
              </div>
              <div class="info-value finance-row">
                <input type="number" class="modern-input small" v-model.number="birthYear" placeholder="Év" min="1900" :max="new Date().getFullYear()" />
                <input type="number" class="modern-input small" v-model.number="birthMonth" placeholder="Hónap" min="1" max="12" />
                <button class="modern-btn modern-btn--primary btn-sm" @click="saveBirth">Mentés</button>
              </div>
            </div>

            <!-- Prepaid balance -->
            <div class="info-item">
              <div class="info-label">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <rect x="2" y="5" width="20" height="14" rx="2"/>
                  <line x1="2" y1="10" x2="22" y2="10"/>
                </svg>
                Egyenleg
              </div>
              <div class="info-value finance-row" :class="{ 'debt': inDebt }">
                <strong>{{ formatHuf(balance) }}</strong>
                <span v-if="inDebt" class="debt-badge">TARTOZÁS</span>
                <span v-else class="ok-badge">RENDBEN</span>
                <button class="modern-btn modern-btn--success btn-sm" @click="topUp">Feltöltés +5000</button>
              </div>
            </div>

            <!-- Díjcsoportok (Fee groups / billing plan) -->
            <div class="info-item" v-if="isAdmin">
              <div class="info-label">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                </svg>
                Díjcsoportok
              </div>
              <div class="info-value">
                <div class="fee-groups-display">
                  <ul class="fee-list">
                    <li v-for="fee in feeGroups" :key="fee.id">
                      <span>{{ fee.group_name }} — {{ fee.billing_mode == 'monthly' ? 'Havi (fix ár)' : 'Óránkénti' }}</span>
                      <button class="modern-btn modern-btn--danger btn-sm" @click="removeFeeGroup(fee.id)">Törlés</button>
                    </li>
                    <li v-if="feeGroups.length === 0" class="muted">Nincs beállított díjcsoport.</li>
                  </ul>
                  <div class="finance-row fee-form">
                    <select class="modern-input small" v-model.number="feeForm.group_id">
                      <option :value="0" disabled>Csoport...</option>
                      <option v-for="g in groups" :key="g.id" :value="g.id">{{ g.name }}</option>
                    </select>
                    <select class="modern-input small" v-model="feeForm.billing_mode">
                      <option value="monthly">Havi (fix ár)</option>
                      <option value="class">Óránként</option>
                    </select>
                    <button class="modern-btn modern-btn--primary btn-sm" @click="addFeeGroup">Hozzáadás</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>


        <!-- 1. Gondviselő adatai -->
        <div class="info-card" v-if="!isDancerRoute">
          <div class="card-header">
            <div class="card-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
                <circle cx="12" cy="7" r="4"/>
              </svg>
            </div>
            <h3>1. Gondviselő adatai</h3>
          </div>
          
          <div class="info-list">
            <div class="info-item">
              <div class="info-label">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                  <polyline points="22,6 12,13 2,6"/>
                </svg>
                Email
              </div>
              <div class="info-value">{{ childInfo.parent1Email || 'Nincs megadva' }}</div>
            </div>

            <div class="info-item">
              <div class="info-label">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
                  <circle cx="12" cy="7" r="4"/>
                </svg>
                Vezetéknév
              </div>
              <div class="info-value" v-if="(isAdmin || canEditProfile()) && isEditingEnabled" @dblclick="editField('parent1xfamily_name')">
                <span v-if="!isEditingField.parent1xfamily_name">{{ childInfo.parent1xfamily_name || 'Nincs megadva' }}</span>
                <input v-if="isEditingField.parent1xfamily_name" v-model="childInfo.parent1xfamily_name" @keydown.enter="updateFieldParent('parent1xfamily_name',childInfo.parent1Email)" @blur="updateFieldParent('parent1xfamily_name',childInfo.parent1Email)" class="modern-input">
              </div>
              <div class="info-value" v-else>{{ childInfo.parent1xfamily_name || 'Nincs megadva' }}</div>
            </div>

            <div class="info-item">
              <div class="info-label">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
                  <circle cx="12" cy="7" r="4"/>
                </svg>
                Keresztnév
              </div>
              <div class="info-value" v-if="(isAdmin || canEditProfile()) && isEditingEnabled" @dblclick="editField('parent1xsure_name')">
                <span v-if="!isEditingField.parent1xsure_name">{{ childInfo.parent1xsure_name || 'Nincs megadva' }}</span>
                <input v-if="isEditingField.parent1xsure_name" v-model="childInfo.parent1xsure_name" @keydown.enter="updateFieldParent('parent1xsure_name',childInfo.parent1Email)" @blur="updateFieldParent('parent1xsure_name',childInfo.parent1Email)" class="modern-input">
              </div>
              <div class="info-value" v-else>{{ childInfo.parent1xsure_name || 'Nincs megadva' }}</div>
            </div>

            <div class="info-item">
              <div class="info-label">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
                </svg>
                Telefonszám
              </div>
              <div class="info-value" v-if="(isAdmin || canEditProfile()) && isEditingEnabled" @dblclick="editField('parent1xphone')">
                <span v-if="!isEditingField.parent1xphone">{{ childInfo.parent1xphone || 'Nincs megadva' }}</span>
                <input v-if="isEditingField.parent1xphone" v-model="childInfo.parent1xphone" @keydown.enter="updateFieldParent('parent1xphone',childInfo.parent1Email)" @blur="updateFieldParent('parent1xphone',childInfo.parent1Email)" class="modern-input">
              </div>
              <div class="info-value" v-else>{{ childInfo.parent1xphone || 'Nincs megadva' }}</div>
            </div>

            <div class="info-item">
              <div class="info-label">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
                  <circle cx="12" cy="10" r="3"/>
                </svg>
                Lakcím
              </div>
              <div class="info-value" v-if="(isAdmin || canEditProfile()) && isEditingEnabled" @dblclick="editField('parent1xaddr')">
                <span v-if="!isEditingField.parent1xaddr">{{ childInfo.parent1xaddr || 'Nincs megadva' }}</span>
                <input v-if="isEditingField.parent1xaddr" v-model="childInfo.parent1xaddr" @keydown.enter="updateFieldParent('parent1xaddr',childInfo.parent1Email)" @blur="updateFieldParent('parent1xaddr',childInfo.parent1Email)" class="modern-input">
              </div>
              <div class="info-value" v-else>{{ childInfo.parent1xaddr || 'Nincs megadva' }}</div>
            </div>
          </div>
        </div>

        <!-- 2. Gondviselő adatai -->
        <div class="info-card" v-if="!isDancerRoute">
          <div class="card-header">
            <div class="card-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
                <circle cx="12" cy="7" r="4"/>
              </svg>
            </div>
            <h3>2. Gondviselő adatai</h3>
          </div>
          
          <div class="info-list">
            <div class="info-item">
              <div class="info-label">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                  <polyline points="22,6 12,13 2,6"/>
                </svg>
                Email
              </div>
              <div class="info-value">{{ (childInfo.parent2Email && childInfo.parent2Email.String) || 'Nincs megadva' }}</div>
            </div>

            <div class="info-item">
              <div class="info-label">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
                  <circle cx="12" cy="7" r="4"/>
                </svg>
                Vezetéknév
              </div>
              <div class="info-value" v-if="(isAdmin || canEditProfile()) && childInfo.parent2Email && childInfo.parent2Email.Valid && isEditingEnabled" @dblclick="editField('parent2xfamily_name')">
                <span v-if="!isEditingField.parent2xfamily_name">{{ (childInfo.parent2xfamily_name && childInfo.parent2xfamily_name.String) || 'Nincs megadva' }}</span>
                <input v-if="isEditingField.parent2xfamily_name" v-model="childInfo.parent2xfamily_name.String" @keydown.enter="updateFieldParent('parent2xfamily_name',childInfo.parent2Email.String)" @blur="updateFieldParent('parent2xfamily_name',childInfo.parent2Email.String)" class="modern-input">
              </div>
              <div class="info-value" v-else>{{ (childInfo.parent2xfamily_name && childInfo.parent2xfamily_name.String) || 'Nincs megadva' }}</div>
            </div>

            <div class="info-item">
              <div class="info-label">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
                  <circle cx="12" cy="7" r="4"/>
                </svg>
                Keresztnév
              </div>
              <div class="info-value" v-if="(isAdmin || canEditProfile()) && childInfo.parent2Email && childInfo.parent2Email.Valid && isEditingEnabled" @dblclick="editField('parent2xsure_name')">
                <span v-if="!isEditingField.parent2xsure_name">{{ (childInfo.parent2xsure_name && childInfo.parent2xsure_name.String) || 'Nincs megadva' }}</span>
                <input v-if="isEditingField.parent2xsure_name" v-model="childInfo.parent2xsure_name.String" @keydown.enter="updateFieldParent('parent2xsure_name',childInfo.parent2Email.String)" @blur="updateFieldParent('parent2xsure_name',childInfo.parent2Email.String)" class="modern-input">
              </div>
              <div class="info-value" v-else>{{ (childInfo.parent2xsure_name && childInfo.parent2xsure_name.String) || 'Nincs megadva' }}</div>
            </div>

            <div class="info-item">
              <div class="info-label">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
                </svg>
                Telefonszám
              </div>
              <div class="info-value" v-if="(isAdmin || canEditProfile()) && childInfo.parent2Email && childInfo.parent2Email.Valid && isEditingEnabled" @dblclick="editField('parent2xphone')">
                <span v-if="!isEditingField.parent2xphone">{{ (childInfo.parent2xphone && childInfo.parent2xphone.String) || 'Nincs megadva' }}</span>
                <input v-if="isEditingField.parent2xphone" v-model="childInfo.parent2xphone.String" @keydown.enter="updateFieldParent('parent2xphone',childInfo.parent2Email.String)" @blur="updateFieldParent('parent2xphone',childInfo.parent2Email.String)" class="modern-input">
              </div>
              <div class="info-value" v-else>{{ (childInfo.parent2xphone && childInfo.parent2xphone.String) || 'Nincs megadva' }}</div>
            </div>

            <div class="info-item">
              <div class="info-label">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
                  <circle cx="12" cy="10" r="3"/>
                </svg>
                Lakcím
              </div>
              <div class="info-value" v-if="(isAdmin || canEditProfile()) && childInfo.parent2Email && childInfo.parent2Email.Valid && isEditingEnabled" @dblclick="editField('parent2xaddr')">
                <span v-if="!isEditingField.parent2xaddr">{{ (childInfo.parent2xaddr && childInfo.parent2xaddr.String) || 'Nincs megadva' }}</span>
                <input v-if="isEditingField.parent2xaddr" v-model="childInfo.parent2xaddr.String" @keydown.enter="updateFieldParent('parent2xaddr',childInfo.parent2Email.String)" @blur="updateFieldParent('parent2xaddr',childInfo.parent2Email.String)" class="modern-input">
              </div>
              <div class="info-value" v-else>{{ (childInfo.parent2xaddr && childInfo.parent2xaddr.String) || 'Nincs megadva' }}</div>
            </div>
          </div>
        </div>

        <!-- Házifeladat Section -->
        <div class="info-card">
          <div class="card-header">
            <div class="card-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                <polyline points="14,2 14,8 20,8"/>
                <line x1="16" y1="13" x2="8" y2="13"/>
                <line x1="16" y1="17" x2="8" y2="17"/>
              </svg>
            </div>
            <h3>Házifeladat</h3>
          </div>
          
          <div class="info-list">
            <div class="info-item">
              <div class="info-value homework-content">
                <p v-if="homework">{{ homework }}</p>
                <p v-else class="no-homework">Nincs házifeladat megadva.</p>
              </div>
            </div>
          </div>
        </div>

        <!-- Visszajelzés Section -->
        <div v-if="childInfo.childGrpId && childInfo.childGrpId.Valid && !isAdmin && !isTeacher" class="info-card">
          <div class="card-header">
            <div class="card-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
              </svg>
            </div>
            <h3>Visszajelzés</h3>
          </div>
          
          <div class="info-list">
            <div class="info-item">
              <div class="info-label">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M9 12l2 2 4-4"/>
                </svg>
                Részvétel
              </div>
              <div class="info-value">
                <p class="response-description">Jelezd vissza, hogy részt veszel a táncórán</p>
                <button class="modern-btn modern-btn--primary" @click="getHash('cresp')">
                  Visszajelzés
                </button>
              </div>
            </div>

            <div class="info-item" v-if="!isDancerRoute">
              <div class="info-label">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
                </svg>
                Táncos leadása
              </div>
              <div class="info-value">
                <p class="response-description">Jelezd, hogy leadod a táncost a táncórára</p>
                <button class="modern-btn modern-btn--success" @click="getHash('cdrof')">
                  Leadás
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Aktivítás Section -->
        <div v-if="isAdmin && childInfo.status" class="info-card">
          <div class="card-header">
            <div class="card-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M9 12l2 2 4-4"/>
                <path d="M21 12c-1 0-3-1-3-3s2-3 3-3 3 1 3 3-2 3-3 3"/>
              </svg>
            </div>
            <h3>Aktivítás</h3>
          </div>
          
          <div class="info-list">
            <div class="info-item">
              <div class="info-label">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M9 12l2 2 4-4"/>
                </svg>
                Állapot
              </div>
              <div class="info-value">
                <select v-model="childInfo.status.String" @change="updateChildActiveStatus" class="modern-select">
                  <option value="Inactive">Inaktív</option>
                  <option value="Active">Aktív</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-else>
      <p>Loading...</p>
    </div>
  </div>
</template>


<script>
import axios from 'axios';
import toastMixin from '../mixins/toast.js';

export default {
  mixins: [toastMixin],
  data() {
    return {
      childInfo: null,
      childGroups: [], // Child's assigned groups
      upcomingLessons: [],
      upcomingCompetitions: [],
      isAdmin: false,
      isTeacher: false,
      isAssistant: false,
      userId: null,
      isDancerRoute: false,
      eventGroups: [], // All available groups
      homework: "",
      isEditingField: {
        childxskill: false,
        childxaddr: false,
        childxfamily_name: false,
        childxsure_name: false,
        parent1xfamily_name: false,
        parent1xsure_name: false,
        parent1xphone: false,
        parent1xaddr: false,
        parent2xfamily_name: false,
        parent2xsure_name: false,
        parent2xphone: false,
        parent2xaddr: false,
      },
    isEditingEnabled: false,
    // Group management
    isAddingGroup: false,
    selectedGroupToAdd: "",
    isPrimaryForNewGroup: false,
    // Student-centric finance
    birthYear: null,
    birthMonth: null,
    balance: 0,
    inDebt: false,
    feeGroups: [],
    groups: [],
    feeForm: { billing_mode: 'monthly', group_id: 0 },
    components: {
      AddNewChldItem
    },


    };
  },
  computed: {
    availableGroupsForUser() {
      // If user is admin, show all groups
      if (this.isAdmin) {
        return this.eventGroups;
      }
      
      // If user is teacher, we'll filter this in getGroups method
      // For now return all groups, filtering happens in getGroups
      return this.eventGroups;
    },
  },
  mounted() {
    this.isAdmin = this.$isAdmin();
    this.isTeacher = this.$isTeacher();
    this.isAssistant = this.$isAssistant();
    this.userId = this.$getUserId();
    this.childId = this.$route.params.id;

    if (this.childId === undefined) {
      this.childId = this.$getChildId();
    }

    // When opened as a dancer (the user IS the dancer), the route param is the
    // dancer's user id; the underlying dancer record id is resolved by the
    // backend. Fetch the profile first, then load the dependent data so the
    // resolved record id is available to the sub-calls.
    this.isDancerRoute = this.$route.path.startsWith('/dancer/');
    this.fetchChildInfo().then(() => {
      this.fetchChildGroups();
      this.getHomework();
      //this.loadAvailableTickets();
      this.getGroups();
      this.fetchFinance();
      this.fetchUpcomingLessons();
      this.fetchCompetitions();
    });
  },
  methods: {
    enableEditing(){
      this.isEditingEnabled = true;
    },
    disableEditing() {
      this.isEditingEnabled = false;
    },

    async fetchChildInfo() {
      try {
        if (this.childId == -1) return;
        const base = this.isDancerRoute
          ? `${this.$BACKEND_HOST}/api/dancer/${this.childId}`
          : `${this.$BACKEND_HOST}/api/child/${this.childId}`;
        const response = await fetch(base);
        if (!response.ok) throw new Error('Failed to fetch data');
        const main_data = await response.json();
        if (main_data.message === 'done') {
          const data = main_data.data;

          console.log(data);
          // For the dancer route the backend resolved the underlying dancer
          if (this.isDancerRoute && main_data.child_id) {
            this.childId = main_data.child_id;
          }
          // The x is only there to split on it. So the actual stuff that's needed can be be intact eg family_name
           this.childInfo = {
             childxskill: data.skill,
             childxfamily_name: data.child_family_name,
             childxsure_name: data.child_sure_name,
             childxaddr: data.child_addr,
             childGrpId: data.child_grp_id,

             childDesiredGrpId: data.child_desired_grp_id,
             eventGroupName: data.event_group_name,
             eventGroupSchedule: data.event_group_schedule,
             parent1Email: data.parent_1_email,
             parent1xaddr: data.parent_1_addr,
             parent1xfamily_name: data.parent_1_family_name,
             parent1xsure_name: data.parent_1_sure_name,
             parent1xphone: data.parent_1_phone,
             mainUserBirthDate: data.main_user_birth_date,
             parent2Email: data.parent_2_email,
             parent2xaddr: data.parent_2_addr,
             parent2xfamily_name: data.parent_2_family_name,
             parent2xsure_name: data.parent_2_sure_name,
             parent2xphone: data.parent_2_phone,
             status: data.child_status,
             is_competitor: data.is_competitor || false,
           };
        }
      } catch (error) {
        console.error('Error fetching child information:', error);
      }
    },
    async updateCompetitor(newValue) {
      try {
        const response = await axios.put(`${this.$BACKEND_HOST}/api/children/${this.childId}/competitor`, {
          is_competitor: newValue
        });
        if (response.status === 200) {
          this.childInfo.is_competitor = newValue;
          if (this.showToast) {
            this.showToast('Versenyzői státusz frissítve!', 'success');
          }
        }
      } catch (error) {
        console.error('Error updating competitor status:', error);
      }
    },
    // ----- Student-centric finance & birth data -----
    async fetchFinance() {
      await Promise.all([this.fetchBirth(), this.fetchBalance(), this.fetchGroups(), this.fetchFeeGroups()]);
    },
    async fetchBirth() {
      try {
        const r = await fetch(this.$BACKEND_HOST + `/api/students/${this.childId}/birth`);
        const d = await r.json();
        this.birthYear = d.birth_year || null;
        this.birthMonth = d.birth_month || null;
      } catch (e) { console.error(e); }
    },
    async saveBirth() {
      try {
        await fetch(this.$BACKEND_HOST + '/api/students/birth', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ child_id: parseInt(this.childId), birth_year: this.birthYear || 0, birth_month: this.birthMonth || 0 }),
        });
      } catch (e) { console.error(e); }
    },
    async fetchBalance() {
      try {
        const r = await fetch(this.$BACKEND_HOST + `/api/students/${this.childId}/balance`);
        const d = await r.json();
        this.balance = d.balance || 0;
        this.inDebt = d.in_debt === true;
      } catch (e) { console.error(e); }
    },
    async topUp() {
      try {
        const r = await fetch(this.$BACKEND_HOST + '/api/students/balance/topup', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ child_id: parseInt(this.childId), amount: 5000 }),
        });
        const d = await r.json();
        this.balance = d.balance || 0;
        this.inDebt = d.in_debt === true;
      } catch (e) { console.error(e); }
    },
    async fetchFeeGroups() {
      try {
        const r = await fetch(this.$BACKEND_HOST + `/api/billing/plans/${this.childId}`);
        const d = await r.json();
        this.feeGroups = (d.plans || []).map(p => ({
          id: p.id,
          group_name: p.group_name,
          billing_mode: p.billing_mode,
          group_id: p.group_id,
        }));
      } catch (e) { console.error(e); }
    },
    async addFeeGroup() {
      if (!this.feeForm.group_id) return;
      try {
        const r = await fetch(this.$BACKEND_HOST + '/api/billing/plans', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            child_id: parseInt(this.childId),
            group_id: this.feeForm.group_id,
            billing_mode: this.feeForm.billing_mode,
            is_active: true,
          }),
        });
        if (r.ok) {
          this.feeForm = { billing_mode: 'monthly', group_id: 0 };
          this.fetchFeeGroups();
        }
      } catch (e) { console.error(e); }
    },
    async removeFeeGroup(id) {
      try {
        await fetch(this.$BACKEND_HOST + `/api/billing/plans/${id}`, { method: 'DELETE' });
        this.fetchFeeGroups();
      } catch (e) { console.error(e); }
    },
    async fetchGroups() {
      try {
        const r = await fetch(this.$BACKEND_HOST + '/api/settings/groups/info');
        const d = await r.json();
        this.groups = d.groups || [];
      } catch (e) { console.error(e); }
    },
    formatHuf(v) {
      return (v || 0).toLocaleString('hu-HU') + ' HUF';
    },
    async getHash(respType) {
      try {
        const response = await axios.post(this.$BACKEND_HOST + '/api/getchildhash', {
          child_id: parseInt(this.childId),
          child_grp: this.childInfo.childGrpId.Int64,
        });

        if (response.status === 200 && response.data.message == "done") {
          this.$router.push({path:`/${respType}/${response.data.hash}`});
        }
      } catch (error) {
        console.error('Error updating event group:', error);
      }
    },
    async updateEventGroupName() {
      try {
        const response = await axios.post(this.$BACKEND_HOST + '/api/updatechildgroup', {
          child_id: parseInt(this.childId),
          group_id: this.newEventGroupId,
        });

        if (response.status === 200) {
          this.childInfo.newEventGroupId = this.newEventGroupId;
          await this.fetchChildInfo();
          this.isEditingEventGroup = false; // Stop editing after successful update
        }
      } catch (error) {
        console.error('Error updating event group:', error);
      }
    },
    async updateChildActiveStatus() {
      try {
        const response = await axios.post(this.$BACKEND_HOST + '/api/update-child-active', {
          child_id: parseInt(this.childId),
          child_status: this.childInfo.status.String,
        });

        if (response.status === 200) {
          await this.fetchChildInfo();
        }
      } catch (error) {
        console.error('Error updating event group:', error);
      }
    },
    async getHomework() {
      try {
        const response = await axios.post(this.$BACKEND_HOST + '/api/gethomework', {
          child_id: parseInt(this.childId),
        });

        if (response.status === 200) {
          this.homework = response.data.homework
        }
      } catch (error) {
        console.error('Error getting homework:', error);
      }
    },
    async editEventGroupName() {
      // Re-fetch groups to ensure we have the latest data with proper filtering
      await this.getGroups();
      this.isEditingEventGroup = true;
      this.newEventGroupName = this.childInfo.eventGroupName; // Pre-fill the current value
    },
    async getGroups() {
      var resp = await this.getGroupDates();
      this.eventGroups = []
      
      resp.groups.forEach(g => {
        this.eventGroups.push({id:g.id,name:g.name});
      });

      // If user is a teacher, filter to only show assigned groups
      if (this.isTeacher && !this.isAdmin && this.userId) {
        try {
          const teacherResponse = await fetch(`${this.$BACKEND_HOST}/api/settings/teachers/groups?teacher_id=${this.userId}`);
          if (teacherResponse.ok) {
            const teacherData = await teacherResponse.json();
            const assignedGroupIds = teacherData.groups.map(g => g.id);
            
            // Filter eventGroups to only show assigned groups
            this.eventGroups = this.eventGroups.filter(group => assignedGroupIds.includes(group.id));
          }
        } catch (error) {
          console.error("Error fetching teacher groups:", error);
          // If there's an error, show no groups to teacher
          this.eventGroups = [];
        }
      }
    },
    doNotUpdateGroup() {
      this.isEditingEventGroup = false;
    },
    async getGroupDates() {
      try {
        const response = await fetch(this.$BACKEND_HOST + '/api/groupdates');
        return await response.json();
      } catch (err) {
        this.error = err.message;
      }
    },
    async fetchChildGroups() {
      try {
        if (this.childId == -1) return;
        const response = await fetch(`${this.$BACKEND_HOST}/api/child/${this.childId}/groups`);
        if (!response.ok) throw new Error('Failed to fetch child groups');
        const data = await response.json();
        if (data.message === 'done') {
          this.childGroups = data.groups || [];
        }
      } catch (error) {
        console.error('Error fetching child groups:', error);
        this.childGroups = [];
      }
    },
    async addGroup() {
      try {
        const response = await axios.post(this.$BACKEND_HOST + '/api/child/groups/add', {
          child_id: parseInt(this.childId),
          group_id: parseInt(this.selectedGroupToAdd),
          is_primary: this.isPrimaryForNewGroup,
        });

        if (response.status === 200) {
          await this.fetchChildGroups();
          this.cancelAddingGroup();
        }
      } catch (error) {
        console.error('Error adding group:', error);
      }
    },
    async removeGroup(groupId) {
      try {
        const response = await axios.post(this.$BACKEND_HOST + '/api/child/groups/remove', {
          child_id: parseInt(this.childId),
          group_id: parseInt(groupId),
        });

        if (response.status === 200) {
          await this.fetchChildGroups();
        }
      } catch (error) {
        console.error('Error removing group:', error);
      }
    },
    async setPrimaryGroup(groupId) {
      try {
        const response = await axios.post(this.$BACKEND_HOST + '/api/child/groups/set-primary', {
          child_id: parseInt(this.childId),
          group_id: parseInt(groupId),
        });

        if (response.status === 200) {
          await this.fetchChildGroups();
        }
      } catch (error) {
        console.error('Error setting primary group:', error);
      }
    },
    startAddingGroup() {
      this.isAddingGroup = true;
      this.selectedGroupToAdd = "";
      this.isPrimaryForNewGroup = this.childGroups.length === 0;
    },
    cancelAddingGroup() {
      this.isAddingGroup = false;
      this.selectedGroupToAdd = "";
      this.isPrimaryForNewGroup = false;
    },

    canEditProfile() {
      if (this.isAdmin) return true;
      if (this.isDancerRoute) return true;
      if (this.$isDancer && this.$isDancer()) return true;
      const sessChildId = this.$getChildId ? this.$getChildId() : null;
      if (sessChildId && (sessChildId == this.childId || sessChildId == parseInt(this.childId))) return true;
      const sessUserId = this.$getUserId ? this.$getUserId() : null;
      if (sessUserId && this.childInfo) {
        if (sessUserId == this.childInfo.mainUserId || sessUserId == this.childInfo.parentId) {
          return true;
        }
      }
      return false;
    },

    // This method is triggered when the user double-clicks on the field to start editing
    editField(fieldName) {
      this.isEditingField[fieldName] = true;
    },

    // This method is triggered when the input loses focus to save the changes
    async updateFieldChild(fieldName) {
      this.isEditingField[fieldName] = false;
      try {
        const response = await axios.post(this.$BACKEND_HOST + '/api/updatechildinfo', {
          chld_id: parseInt(this.childId),
          info_to_change: fieldName.split("x")[1],
          new_info: this.childInfo[fieldName],
        });
        if (response.status === 200 && this.showToast) {
          this.showToast('Adatok sikeresen frissítve!', 'success');
        }
      } catch (error) {
        console.error('Error updating item:', error);
        if (this.showToast) {
          this.showToast('Sikertelen frissítés!', 'error');
        }
      }
    },
    async updateFieldParent(fieldName, email) {
      this.isEditingField[fieldName] = false;
      try {
        const response = await axios.post(this.$BACKEND_HOST + '/api/updateparentinfo', {
          parent_email: email,
          info_to_change: fieldName.split("x")[1],
          new_info: typeof(this.childInfo[fieldName]) == "string" ? this.childInfo[fieldName] : (this.childInfo[fieldName] ? this.childInfo[fieldName].String : ''),
        });
        if (response.status === 200 && this.showToast) {
          this.showToast('Adatok sikeresen frissítve!', 'success');
        }
      } catch (error) {
        console.error('Error updating item:', error);
        if (this.showToast) {
          this.showToast('Sikertelen frissítés!', 'error');
        }
      }
    },
      getGroupNameById(groupId) {
        const group = this.eventGroups.find(g => g.id === groupId);
        return group ? group.name : 'Ismeretlen csoport';
      },
      async fetchCompetitions() {
        try {
          const r = await fetch(this.$BACKEND_HOST + '/api/competitions/home');
          const d = await r.json();
          this.upcomingCompetitions = d.events || [];
        } catch (e) { console.error(e); }
      },
      async fetchUpcomingLessons() {
        try {
          const r = await fetch(this.$BACKEND_HOST + '/api/user/upcoming-lessons');
          const d = await r.json();
          this.upcomingLessons = d.lessons || [];
        } catch (e) { console.error(e); }
      },
      parseSchedule(schedule) {
        try {
          const daysOfWeek = ["", "Hétfő", "Kedd", "Szerda", "Csütörtök", "Péntek", "Szombat", "Vasárnap"];
          let parsed = JSON.parse(schedule);
          if (!Array.isArray(parsed)) {
            parsed = [parsed];
          }
          return parsed
            .filter(s => s && s.day && s.time)
            .map(s => `${daysOfWeek[s.day]} ${s.time}`)
            .join(", ");
        } catch (e) {
          return "Érvénytelen idő adat";
        }
      }
  }
}
</script>

<style scoped>
.container {
  max-width: 1200px;
}

table {
  background-color: #f8f9fa;
}

th {
  width: 200px;
}

td {
  word-wrap: break-word;
  word-break: break-word;
}

.star {
  color: #ccc;
  font-size: 1.5em;
  margin-right: 5px;
}

.star.sradmin {
  cursor: pointer;
}

.star.filled {
  color: #FFD700; /* Gold color for filled stars */
}

.child-details-container {
  padding: 2rem;
  max-width: 1200px;
  margin: 0 auto;
  background: var(--color-background);
  min-height: 100vh;
}

.content-header {
  text-align: center;
  margin-bottom: 2rem;
  padding: 2rem;
  background: var(--card-bg);
  border-radius: 16px;
  box-shadow: var(--shadow);
  border: 1px solid var(--color-border);
}

.header-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  background: var(--button-primary);
  border-radius: 16px;
  margin-bottom: 1rem;
  color: white;
}

.content-header h1 {
  font-size: 2.5rem;
  font-weight: 700;
  color: var(--color-heading);
  margin: 0 0 0.5rem 0;
}

.content-header p {
  color: var(--color-text-muted);
  font-size: 1.1rem;
  margin: 0;
}

.content-wrapper {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.admin-controls {
  display: flex;
  justify-content: center;
  margin-bottom: 1rem;
}

.modern-btn {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  text-decoration: none;
}

.modern-btn--secondary {
  background: var(--card-bg);
  color: var(--color-text);
  border: 2px solid var(--color-border);
}

.modern-btn--secondary:hover {
  background: var(--color-background-soft);
  border-color: var(--button-primary);
  color: var(--button-primary);
}

.modern-btn--danger {
  background: var(--error);
  color: white;
}

.modern-btn--danger:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-lg);
}

.info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
  gap: 2rem;
}

.info-card {
  background: var(--card-bg);
  border-radius: 16px;
  box-shadow: var(--shadow);
  overflow: hidden;
}

.card-header {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1.5rem 2rem;
  background: var(--color-background-soft);
  border-bottom: 1px solid var(--color-border);
}

.card-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  background: var(--button-primary);
  border-radius: 12px;
  color: white;
}

.card-header h3 {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 600;
  color: var(--color-text);
}

.info-list {
  padding: 1.5rem 2rem;
}

.info-item {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  padding: 1rem 0;
  border-bottom: 1px solid var(--color-border);
}

.info-item:last-child {
  border-bottom: none;
}

.info-label {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  min-width: 140px;
  font-weight: 600;
  color: var(--color-text);
}

.info-label svg {
  color: var(--button-primary);
  flex-shrink: 0;
}

.info-value {
  flex: 1;
  color: var(--color-text-muted);
  word-break: break-word;
}

.modern-input {
  width: 100%;
  padding: 0.75rem 1rem;
  border: 2px solid var(--color-border);
  border-radius: 8px;
  background: var(--card-bg);
  color: var(--color-text);
  font-size: 1rem;
  transition: all 0.2s ease;
}

.modern-input:focus {
  outline: none;
  border-color: var(--button-primary);
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.modern-select {
  width: 100%;
  padding: 0.75rem 1rem;
  border: 2px solid var(--color-border);
  border-radius: 8px;
  background: var(--card-bg);
  color: var(--color-text);
  font-size: 1rem;
  transition: all 0.2s ease;
}

.modern-select:focus {
  outline: none;
  border-color: var(--button-primary);
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.action-buttons {
  display: flex;
  gap: 0.75rem;
  flex-wrap: wrap;
}

.homework-content {
  padding: 1rem;
  background: var(--color-background-soft);
  border-radius: 8px;
  border-left: 4px solid var(--button-primary);
}

.no-homework {
  color: var(--color-text-muted);
  font-style: italic;
}

.response-description {
  color: var(--color-text-muted);
  font-size: 0.875rem;
  margin-bottom: 0.75rem;
}

.group-badge {
  display: inline-block;
  background: var(--success);
  color: white;
  padding: 0.375rem 0.75rem;
  border-radius: 12px;
  font-size: 0.875rem;
  font-weight: 500;
}

.group-badge--desired {
  background: var(--warning);
}

.groups-display {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.no-groups {
  color: var(--color-text-muted);
  font-style: italic;
  padding: 1rem;
  text-align: center;
  background: var(--color-background-soft);
  border-radius: 8px;
}

.groups-list {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.group-badge {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  background: var(--success);
  color: white;
  padding: 0.375rem 0.75rem;
  border-radius: 12px;
  font-size: 0.875rem;
  font-weight: 500;
}

.group-badge--primary {
  background: var(--primary-blue);
  border: 2px solid var(--primary-blue);
}

.primary-indicator {
  font-size: 0.75rem;
  opacity: 0.9;
}

.remove-group-btn {
  background: none;
  border: none;
  color: white;
  cursor: pointer;
  font-size: 1.2rem;
  line-height: 1;
  padding: 0;
  margin-left: 0.25rem;
  opacity: 0.7;
  transition: opacity 0.2s ease;
}

.remove-group-btn:hover {
  opacity: 1;
}

.group-actions {
  margin-top: 0.5rem;
}

.add-group-form {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: wrap;
  margin-top: 0.5rem;
  padding: 1rem;
  background: var(--color-background-soft);
  border-radius: 8px;
  border: 1px solid var(--color-border);
}

.checkbox-group {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-weight: 500;
  color: var(--color-text);
  user-select: none;
}

.modern-checkbox {
  display: none;
}

.checkbox-custom {
  width: 18px;
  height: 18px;
  border: 2px solid var(--color-border);
  border-radius: 4px;
  background: var(--card-bg);
  position: relative;
  transition: all 0.2s ease;
}

.modern-checkbox:checked + .checkbox-custom {
  background: var(--primary-blue);
  border-color: var(--primary-blue);
}

.modern-checkbox:checked + .checkbox-custom::after {
  content: '';
  position: absolute;
  left: 5px;
  top: 2px;
  width: 6px;
  height: 10px;
  border: solid white;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

@media (max-width: 768px) {
  .child-details-container {
    padding: 1rem;
  }

  .content-header {
    padding: 1.5rem;
    margin-bottom: 2rem;
  }

  .content-header h1 {
    font-size: 2rem;
  }

  .header-icon {
    width: 56px;
    height: 56px;
  }

  .info-grid {
    grid-template-columns: 1fr;
  }

  .info-item {
    flex-direction: column;
    gap: 0.5rem;
  }

  .info-label {
    min-width: auto;
  }

  .card-header {
    padding: 1rem 1.5rem;
  }

  .info-list {
    padding: 1rem 1.5rem;
  }
}

@media (max-width: 480px) {
  .child-details-container {
    padding: 0.75rem;
  }

  .content-header {
    padding: 1.25rem;
    margin-bottom: 1.5rem;
  }

  .content-header h1 {
    font-size: 1.75rem;
  }

  .header-icon {
    width: 48px;
    height: 48px;
  }
}

/* Student-centric finance UI */
.finance-row { display: flex; gap: 0.5rem; align-items: center; flex-wrap: wrap; }
.modern-input.small { width: auto; min-width: 90px; padding: 0.4rem 0.6rem; }
.fee-form { margin-top: 0.5rem; }
.fee-list { list-style: none; padding: 0; margin: 0; display: flex; flex-direction: column; gap: 0.4rem; }
.fee-list li { display: flex; align-items: center; gap: 0.5rem; }
.fee-groups-display { width: 100%; }
.debt-badge { background: #d33; color: #fff; padding: 0.15rem 0.5rem; border-radius: 6px; font-size: 0.75rem; font-weight: 700; animation: debt-flash 1.2s ease-in-out infinite; }
.ok-badge { background: #16a34a; color: #fff; padding: 0.15rem 0.5rem; border-radius: 6px; font-size: 0.75rem; font-weight: 700; }
@keyframes debt-flash { 0%,100% { opacity: 1; } 50% { opacity: 0.55; } }
.muted { color: var(--color-text-muted); }
.btn-sm { font-size: 0.8rem; padding: 0.35rem 0.7rem; }

/* Upcoming events section */
.events-section {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(270px, 1fr));
  gap: 1.5rem;
}
.lessons-section,
.competitions-section {
  background: var(--card-bg);
  border-radius: 16px;
  box-shadow: var(--shadow);
  overflow: hidden;
  border: 1px solid var(--color-border);
}
.lessons-section h2,
.competitions-section h2 {
  margin: 0;
  padding: 1.25rem 1.5rem;
  font-size: 1.1rem;
  font-weight: 600;
  color: var(--color-heading);
  background: var(--color-background-soft);
  border-bottom: 1px solid var(--color-border);
}
.lesson-list,
.competition-list {
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}
.lesson-card,
.competition-card {
  background: var(--color-background-soft);
  border-radius: 12px;
  padding: 1rem;
  border: 1px solid var(--color-border);
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}
.lesson-card:hover,
.competition-card:hover {
  transform: translateY(-1px);
  box-shadow: var(--shadow);
}
.lesson-card__name {
  font-weight: 600;
  color: var(--color-text);
  margin-bottom: 0.5rem;
  font-size: 1rem;
}
.lesson-card__details {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  align-items: center;
}
.lesson-card__date {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  background: var(--button-primary);
  color: #fff;
  padding: 0.35rem 0.7rem;
  border-radius: 8px;
  font-size: 0.8rem;
  font-weight: 600;
}
.lesson-card__schedule {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  background: var(--card-bg);
  color: var(--color-text);
  padding: 0.35rem 0.7rem;
  border-radius: 8px;
  font-size: 0.8rem;
  font-weight: 500;
  border: 1px solid var(--color-border);
}
.comp-date {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  background: var(--button-primary);
  color: #fff;
  padding: 0.35rem 0.7rem;
  border-radius: 8px;
  font-size: 0.8rem;
  font-weight: 600;
  margin-bottom: 0.4rem;
}
.comp-title {
  font-weight: 600;
  color: var(--color-text);
  font-size: 0.95rem;
  margin-bottom: 0.25rem;
}
.comp-location {
  color: var(--color-text-muted);
  font-size: 0.85rem;
}

/* Competitor Toggle Switch */
.toggle-switch {
  display: inline-flex;
  align-items: center;
  gap: 0.75rem;
  cursor: pointer;
  user-select: none;
}
.toggle-switch input {
  display: none;
}
.toggle-slider {
  position: relative;
  width: 44px;
  height: 24px;
  background-color: var(--color-border, #ccc);
  border-radius: 24px;
  transition: background-color 0.25s ease;
}
.toggle-slider::before {
  content: '';
  position: absolute;
  top: 2px;
  left: 2px;
  width: 20px;
  height: 20px;
  background-color: white;
  border-radius: 50%;
  transition: transform 0.25s ease;
  box-shadow: 0 1px 3px rgba(0,0,0,0.2);
}
.toggle-switch input:checked + .toggle-slider {
  background-color: var(--button-primary, #3b82f6);
}
.toggle-switch input:checked + .toggle-slider::before {
  transform: translateX(20px);
}
.toggle-text {
  font-weight: 500;
  color: var(--color-text);
  font-size: 0.95rem;
}
</style>
